<section class="group-list" *appHasPermission="groupPermissions.MODULE">
  <app-group-list-header
    [query]="query()"
    [canCreate]="canCreate()"
    [showSearch]="hasGroups()"
    (queryChange)="onQueryChange($event)"
    (create)="addGroup()"></app-group-list-header>

  @if (loading()) {
    <div class="group-list__state" role="status">
      <app-cog-loading-spinner [size]="64"></app-cog-loading-spinner>
      <p>Carregando os grupos de permissão...</p>
    </div>
  } @else if (loadError()) {
    <div class="group-list__state" role="alert">
      <i class="pi pi-exclamation-triangle group-list__state-icon" aria-hidden="true"></i>
      <h2>Não foi possível carregar os grupos.</h2>
      <p>Confira a conexão e use Tentar de novo. Nenhum grupo foi alterado.</p>
      <app-button
        [id]="'retry-groups'"
        label="Tentar de novo"
        icon="refresh"
        theme="white"
        size="medium"
        [noMargin]="true"
        [fitContent]="true"
        (sendButtonClick)="loadGroups()"></app-button>
    </div>
  } @else if (!hasGroups()) {
    <div class="group-list__state">
      <i class="pi pi-users group-list__state-icon" aria-hidden="true"></i>
      <h2>Nenhum grupo de permissão cadastrado.</h2>
      @if (canCreate()) {
        <p>Crie um grupo para dizer o que um tipo de usuário pode ver e fazer.</p>
        <app-button
          [id]="'add-group-empty'"
          label="Novo grupo"
          icon="plus"
          size="medium"
          [noMargin]="true"
          [fitContent]="true"
          (sendButtonClick)="addGroup()"></app-button>
      } @else {
        <p>Peça a um administrador para criar os grupos.</p>
      }
    </div>
  } @else {
    <app-group-role-chips
      [chips]="chips()"
      [selected]="roleFilter()"
      (selectedChange)="roleFilter.set($event)"></app-group-role-chips>

    @if (isTruncated()) {
      <p class="group-list__warning" role="status">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        A lista mostra os primeiros {{ rows().length }} de {{ totalFromServer() }} grupos: o filtro,
        a busca e as contagens valem só para esses.
      </p>
    }

    <div class="group-list__table-wrap">
      <table class="group-list__table">
        <thead [class.group-list__sr-only]="!visibleRows().length">
          <tr>
            <th scope="col">Grupo</th>
            <th scope="col">Tipo de usuário</th>
            <th scope="col">Permissões</th>
            <th scope="col" class="group-list__num">Usuários</th>
            <th scope="col"><span class="group-list__sr-only">Ações</span></th>
          </tr>
        </thead>
        <tbody>
          @for (row of visibleRows(); track row.group.id) {
            <tr
              app-group-list-row
              [row]="row"
              [canUpdate]="canUpdate()"
              [canDelete]="canDelete()"
              (remove)="confirmRemove($event)"></tr>
          }
        </tbody>
      </table>

      @if (!visibleRows().length) {
        <div class="group-list__no-results" role="status">
          <p>{{ emptyFilterText() }}</p>
          @if (query().trim()) {
            <app-button
              [id]="'clear-group-search'"
              label="Limpar busca"
              theme="white"
              size="small"
              [noMargin]="true"
              [fitContent]="true"
              (sendButtonClick)="clearSearch()"></app-button>
          }
        </div>
      }
    </div>

    <p class="group-list__footer">
      {{ footerText() }} Os marcados como <span class="group-list__default">Padrão</span> são
      criados e mantidos pela plataforma e não podem ser excluídos; nos outros, as permissões novas
      precisam ser marcadas à mão.
    </p>
  }
</section>
